export default __webpack_public_path__ + "static/media/img15.f20bc258.png";